// @internal
export function isUndefined(value) {
    return value === undefined;
}
//# sourceMappingURL=isUndefined.js.map